export default function Header() {
  return (
    <header className="bg-cloudflare-orange text-white px-6 py-4 shadow-md">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Value Map Coach</h1>
          <p className="text-sm text-orange-100">Cloudflare Sales Assistant</p>
        </div>
        <div className="text-sm text-orange-100">
          Powered by Workers AI
        </div>
      </div>
    </header>
  );
}
